import React from 'react';
import GameTotalSeats from './GameTotalSeats';
import GameWinsCoefsSection from './GameWinsCoefsSection';
import { IPragmaticLiveInstantInfoProps } from './types';

const PragmaticLiveInstantInfo: React.FC<IPragmaticLiveInstantInfoProps> = ({
  pragmaticInstantData,
  tags,
  showTags,
  isGameCardMinimised
}) => {
  if (!pragmaticInstantData) {
    return null;
  }

  return (
    <>
      <GameTotalSeats
        tags={tags}
        showTags={showTags}
        totalSeatedPlayers={pragmaticInstantData.seatsTaken}
      />
      <GameWinsCoefsSection
        pragmaticInstantData={pragmaticInstantData}
        isGameCardMinimised={isGameCardMinimised}
      />
    </>
  );
};

export default PragmaticLiveInstantInfo;
